<template>
    <div class="architecture-second">
        <div class="architecture-second__description">
            <p class="screen-subtitle -trAnim-1">Solution</p>
            <h2 class="screen-title -trAnim-2">Architecture</h2>
            <div class="architecture-second__scheme">
                <div class="architecture-second__flow-container">
                <div class="gradient-block -trAnim-3"><img src="../assets/logo-dark.png" alt="logo"></div>
                <div class="column">
                    <div class="glass-block block-light -trAnim-4">Central<br>Banking</div>
                    <div class="glass-block block-light -trAnim-5">Legislature</div>
                    <div class="glass-block block-light -trAnim-6">Treasure &<br>Taxation</div>
                    <img src="../assets/images/arrow.png" alt="arrow" class="arrow">
                </div>
                <div class="column">
                    <div class="row">
                        <div class="glass-block block-dark -trAnim-4">Planet 1</div>
                        <div class="glass-block block-dark block-small -trAnim-5">SIDECHAIN</div>
                    </div>
                    <div class="row">
                        <div class="glass-block block-dark -trAnim-5">Planet 2</div>
                        <div class="glass-block block-dark block-small -trAnim-6">SIDECHAIN</div>
                    </div>
                    <div class="row">
                        <div class="glass-block block-dark -trAnim-6">Planet 3</div>
                        <div class="glass-block block-dark block-small -trAnim-7">SIDECHAIN</div>
                    </div>
                    <div class="row">
                        <div class="glass-block block-dark -trAnim-7">Planet 4</div>
                        <div class="glass-block block-dark block-small -trAnim-8">SIDECHAIN</div>
                    </div>
                    <div class="row">
                        <div class="glass-block block-dark -trAnim-8">Planet 5</div>
                        <div class="glass-block block-dark block-small -trAnim-9">SIDECHAIN</div>
                    </div>
                    <img src="../assets/images/arrow-2.png" alt="arrow" class="arrow">
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'architectureSecondScreen',
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
    .architecture-second {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: stretch;

        @media screen and (max-width: point(sm)) {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            background: url(../assets/images/blur-6.png) no-repeat;
            background-size: contain;
            background-position: center;
            width: 150vh;
            height: 150vh;
            right: -30vh;
            top: -25vh;
            opacity: .7;
            z-index: 1;
        }
    }
    .architecture-second__description {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        z-index: 2;
        width: 100%;

        @media screen and (max-width: point(sm)) {
            width: 100vw;
        }

        .screen-subtitle {
            margin-top: 2rem;

            @media screen and (max-width: point(sm)) {
                margin-left: 2rem;
            }
        }

        .screen-title {
            position: relative;
            margin-top: 1rem;

            @media screen and (max-width: point(sm)) {
                margin-left: 2rem;
            }
        }
    }

    .architecture-second__flow-container {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 3%;

        @media screen and (max-width: point(sm)) {
            flex-direction: column;
            margin-left: 2rem;
            margin-right: 2rem;
            margin-top: 0;
            height: 100%;
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 3px;
            background: color('white');
            top: calc(49.25%);
            opacity: .5;
            left: 12%;

            @media screen and (max-width: point(sm)) {
                width: 1px;
                height: 13rem;
                top: 0;
                left: 49.5%;
            }
        }
    }
    .architecture-second__scheme {
        @media screen and (max-width: point(sm)) {
            display: flex;
            justify-content: flex-start;
            padding-bottom: 4rem;
            margin-top: 3rem;
            max-width: 100%;
            overflow-y: auto;
        }

        .column {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;

            @media screen and (max-width: point(sm)) {
                flex-direction: row;
                justify-content: center;
                margin-top: 5%;
            }

            > [class*="block"]:not(:first-child), .row:not(:first-child) {
                margin-top: 10%;

                @media screen and (max-width: point(sm)) {
                    margin-top: 0;
                    margin-left: 1rem;
                }
            }

            .row {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                @media screen and (max-width: point(sm)) {
                    flex-direction: column;
                }

                > div:last-child {
                    margin-top: 0;
                    margin-left: 5%;

                    @media screen and (max-width: point(sm)) {
                        margin-left: 0;
                        margin-top: 7%;
                    }
                }
            }
        }

        .arrow {
            position: absolute;
            height: calc(100% - 4rem);
            width: auto;
            top: 2rem;
            right: 100%;

            @media screen and (max-width: point(sm)) {
                // bottom: calc(100%);
                top: -120%;
                height: auto;
                width: 18%;
                transform: rotate(-270deg);
                right: 41%;

                // hide
                display: none;
            }
        }

        .column:nth-child(2) {
            position: relative;
            margin-left: 21%;
            @media screen and (max-width: point(sm)) {
                margin-left: 0;
            }
        }
        .column:nth-child(3) {
            margin-left: 34%;
            @media screen and (max-width: point(sm)) {
                margin-left: 0;
                margin-top: 5%;
            }
            .arrow {
                top: 2.15rem;
                @media screen and (max-width: point(sm)) {
                    width: 12%;
                    top: -118%;
                    right: 44%;
                }
            }
        }
    }
    .architecture-second__scheme {
        .gradient-block {
            padding: 0.75rem 3.1875rem;
            background: linear-gradient(93.77deg, #6C6AFF -4.61%, #FBC7D4 80.26%, #FF658B 140%);
            box-shadow: inset 1px 1px 2px rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(180px);
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .glass-block {
            @include font-bold;
            font-size: font(20);
            padding: 1.25rem 3rem;
            box-shadow: inset 1px 1px 2px rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(40px);
            line-height: 1.75rem;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            white-space: nowrap;
            @media screen and (max-width: point(sm)) {
                @include font-medium;
                font-size: font(16);
                padding: .5rem 1.5rem;
                line-height: 1.25rem;
            }

            &.block-dark {
                background: rgba(251, 199, 212, 0.1);
            }
            &.block-light {
                background: rgba(251, 199, 212, 0.1)
            }
            &.block-small {
                @include font-medium;
                font-size: font(16);
                padding: 0.625rem 1.25rem;
                text-transform: uppercase;
            }
        }
    }

    // animation styles before
    .architecture-second {
        .architecture-second__flow-container:before {
            opacity: 0;
            max-width: 0;
            transition: var(--content-appear-time) opacity .4s, var(--content-appear-time) max-width .4s;

            @media screen and (max-width: point(sm)) {
                max-width: 100%;
                max-height: 0;
            }
        }

        .arrow {
            opacity: 0;
            max-width: 0;
            transition: calc(var(--content-appear-time) + .5s) opacity .4s, calc(var(--content-appear-time) + .5s) max-width .4s;
        }

        &:before {
            opacity: 0;
            transition: calc(var(--content-appear-time) + .5s) opacity;
        }
    }
    // animation styles after
    .architecture-second.active {
        .architecture-second__flow-container:before {
            opacity: .3;
            max-width: 100%;

            @media screen and (max-width: point(sm)) {
                max-height: 100%;
            }
        }
        .arrow {
            opacity: 1;
            max-width: 15rem;
        }
        &:before {
            opacity: 1;
        }
    }

</style>
